import { render, staticRenderFns } from "./ModelField.vue?vue&type=template&id=3aae9aca&scoped=true&"
import script from "./ModelField.vue?vue&type=script&lang=js&"
export * from "./ModelField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae9aca",
  null
  
)

export default component.exports